var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading === false)?_c('icon-set',{staticClass:"toggle-project-list",attrs:{"icon":_vm.icon},nativeOn:{"click":function($event){$event.preventDefault();return _vm.toggle($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }